import Box from '@mui/material/Box'
import CardContent from '@mui/material/CardContent'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'

const FormSection = ({ title, children, contentSx }) => (
  <Box>
    <Paper elevation={2} sx={{ borderRadius: 0, padding: 1 }}>
      <Typography
        fontWeight={'bold'}
        color={theme => theme.palette.secondary_80.main}
        textAlign="center"
      >
        {title}
      </Typography>
    </Paper>
    <CardContent
      sx={{
        padding: 3,
        mt: 1,
        mb: 2,
        color: theme => theme.palette.secondary_80.main,
        ...contentSx,
      }}
    >
      {children}
    </CardContent>
  </Box>
)

export default FormSection
